const Cookie = require('js-cookie');

const getSession = () => {
  let auth = Cookie.get('auth')
  return (auth) ? JSON.parse(auth):null
}

const setSession = (jwtData) => {
  if (jwtData)
    Cookie.set('auth', JSON.stringify(jwtData))
}

const removeSession = (jwtData) => {
  Cookie.remove('auth')
}

export default {
  getSession,
  setSession,
  removeSession
}
